/**
 * 协议书
 */
export default {
  name: 'protocol'
}
